import ReactDOM from 'react-dom';
import React from 'react';
import bottomRightYellowBgImage from '../../images/bottomRightYellowBgImage.svg';
import bottomRightBlueBgImage from '../../images/bottomRightBlueBgImage.svg';
import topLeftYellowBgImage from '../../images/topLeftYellowBgImage.svg';
import topLeftPeachBgImage from '../../images/topLeftPeachBgImage.svg';

import styles from './background.module.scss';

export const BG_IMAGES = {
  bottomRightYellowBgImage,
  bottomRightBlueBgImage,
  topLeftYellowBgImage,
  topLeftPeachBgImage,
};

interface BackgroundImagesProps {
  showTopImage?: boolean;
  showBottomImage?: boolean;
  topImage?: string;
  bottomImage?: string;
}

const BackgroundImages = ({
  showTopImage = true,
  showBottomImage = true,
  topImage = topLeftYellowBgImage,
  bottomImage = bottomRightBlueBgImage,
}: BackgroundImagesProps) => {
  return ReactDOM.createPortal(
    <div className={styles.root}>
      {showTopImage ? (
        <img src={topImage} className={styles.bgTop} alt="topleftBgImage"></img>
      ) : null}
      {showBottomImage ? (
        <img src={bottomImage} className={styles.bgBottom} alt="bottom"></img>
      ) : null}
    </div>,
    document.getElementById('bg-images') as HTMLElement
  );
};

export default BackgroundImages;
